import { cn } from "@omni/utils/styles";
import { JSX } from "react";

import { Label } from "@/components/Form/Base/label.component";

type AutocompleteHeaderProps = {
    headerTitle: string;
    className?: string;
    children?: JSX.Element[] | JSX.Element;
};

const AutocompleteHeader = ({
    headerTitle,
    className,
    children
}: AutocompleteHeaderProps) => {
    return (
        <div
            className={cn(
                "text-primary d-flex justify-content-between align-content-center",
                className
            )}
        >
            <Label className={"font-weight-bold py-2 m-0"}>{headerTitle}</Label>
            {children}
        </div>
    );
};

export default AutocompleteHeader;
